import { Divider, Layout } from 'antd';
import type React from 'react';

import { GlobalMappingLauncher } from 'src/components/global-mapping-launcher/global-mapping-launcher';
import { useCatalogGamesCreationResultsPolling } from 'src/hooks/data/catalog-games';
import { Logo } from './logo/logo';
import { Profile } from './profile/profile';

export const Header: React.FC = () => {
  useCatalogGamesCreationResultsPolling();

  return (
    <Layout.Header className="flex items-center justify-between px-24 h-64">
      <Logo />

      <div className="flex items-center gap-x-4">
        <GlobalMappingLauncher />
        <Divider vertical className="bg-gray-7 h-32" />
        <Profile />
      </div>
    </Layout.Header>
  );
};
